import { ResetUserPasswordComponent } from './ResetUserPassword.types';
import { useIntl } from 'react-intl';
import { useResetUserPasswordForm } from '../../hooks/useResetUserPasswordForm';
import { useParams } from 'react-router-dom';
import { Box, Button, Flexbox, TextField, Typography } from '@hiiretail/synergy-ui';
import { ProfileMessages } from '../../../Profile/Profile.messages';
import { ErrorBox } from '../../../../common/components/ErrorBox/ErrorBox';
import { Controller } from 'react-hook-form';
import { ResetUserPasswordFormWrapper } from './ResetUserPassword.styles';
import { UserDetailsMessages } from '../../UserDetails.messages';
import { Divider } from '../../../Profile/ui/GeneralInfoForm/GeneralInfoForm';

export const ResetUserPassword: ResetUserPasswordComponent = ({
  resetError,
  isResetting,
  resetUserPassword,
}) => {
  const intl = useIntl();
  const { id } = useParams<{ id: string }>();
  const { control, handleSubmit, formState } = useResetUserPasswordForm();

  const onSubmit = (data: { newPassword: string }) => {
    resetUserPassword({ resetPasswordDto: data, userId: id });
  };

  return (
    <ResetUserPasswordFormWrapper item style={{ height: '100%', width: '100%' }}>
      <Typography variant="body1">{intl.formatMessage(ProfileMessages.resetPassword)}</Typography>
      <Box my={4}>
        <Divider />
      </Box>
      <ErrorBox error={resetError} />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flexbox container direction="column" gutter={4}>
          <Flexbox item>
            <Controller
              name="newPassword"
              defaultValue=""
              control={control}
              render={({ field: { ref, value, onChange } }) => (
                <TextField
                  id="new-user-password"
                  autoComplete="new-user-password"
                  fullWidth
                  label={intl.formatMessage(UserDetailsMessages.newPassword)}
                  name="newPassword"
                  disabled={isResetting}
                  type="password"
                  ref={ref}
                  value={value}
                  onChange={onChange}
                  error={formState.errors?.newPassword?.message}
                />
              )}
            />
          </Flexbox>
          <Flexbox item container justifyContent="flex-end">
            <Button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              disabled={
                (formState?.errors && !!Object.entries(formState?.errors).length) ||
                Object.keys(formState?.dirtyFields).length < 1 ||
                isResetting
              }
            >
              {isResetting ? 'Resetting ...' : 'Reset'}
            </Button>
          </Flexbox>
        </Flexbox>
      </form>
    </ResetUserPasswordFormWrapper>
  );
};
